import React from "react";
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import Select from "react-select";
import {Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {
    Aux,
    BASE_URL,
    getIsBaseDropOff, GetUserLocation,
    IsInRole,
    IsNullOrUndefined,
    LOCATION_TYPE_BASE_CODE,
    SHORT_DATE_FORMAT
} from "../../constants";
import QrReader from "react-qr-reader";
import querySearch from "stringquery";
import {apiPost, apiRequest} from "../../utils/request";
import {toastr} from "react-redux-toastr";
import TextViewControl from "../Common/TextViewControl";
import {push} from "../../utils/navigation";
import {Link} from "react-router-dom";
import CheckBoxControl from "../Common/CheckBoxControl";
import moment from "moment";
import TextBoxControl from "../Common/TextBoxControl";
import FileSaver from "file-saver";
import { mustBeArray } from "../../utils/lib";
import { withRouter } from '../../utils/withRouter';

const TankStatusTypes = [
    {
        value: 0,
        label: 'Active'
    },
    {
        value: 1,
        label: 'In-Active'
    },
    {
        value: 2,
        label: 'Pending - New'
    },
    {
        value: 3,
        label: 'Pending - Ready'
    },
    {
        value: 4,
        label: 'Pending - Clean'
    },
    {
        value: 5,
        label: 'Pending - Refurbish'
    },
    {
        value: 6,
        label: 'Pending - In transit'
    },
];

class TankManagementPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
          selectedTank: null,
          lookupTank: null,
          isModalOpen: false,
          printOffset: 0,
          locations: [],
          baseLocations: [],
          recordLocation: true,
          oilTypesOptions: [],
          assetTypes: []
        };

        this.onScan = this.onScan.bind(this);
        this.onScanError = this.onScanError.bind(this);
        this.handleLookupTank = this.handleLookupTank.bind(this);
        this.handleSetTankId = this.handleSetTankId.bind(this);
        this.loadTank = this.loadTank.bind(this);
        this.fetchTanks = this.fetchTanks.bind(this);
        this.handleSaveTank = this.handleSaveTank.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleConfirmPrint = this.handleConfirmPrint.bind(this);
        this.fetchLocations = this.fetchLocations.bind(this);    
        this.fetchOilTypes = this.fetchOilTypes.bind(this);
        this.fetchAssetTypes = this.fetchAssetTypes.bind(this);
    }

    fetchLocations() {
        let {lookupTank} = this.state;
        if(IsNullOrUndefined(lookupTank)){
            toastr.error("No tank selected to lookup locations");
            return;
        }
        let {currentTankLocationId, currentTankLocationName} = lookupTank;
        
        apiRequest(`/api/managelocations?locationTypes=B&locationTypes=D`)
            .then(x => {
                if (Array.isArray(x.data)) {
                    let locations = [...x.data.map(y => {
                        return {label: `${y.locationName} (${getIsBaseDropOff(y)})`, value: y.id};
                    })];
                    let baseLocations = [...x.data.filter(y => y.locationTypeUniqueCode === LOCATION_TYPE_BASE_CODE).map(y => {
                        return {label: `${y.locationName} (${getIsBaseDropOff(y)})`, value: y.id};
                    })];
                    
                    if(locations.findIndex(x => x.value === currentTankLocationId) < 0){                        
                        locations = [...locations, {label: currentTankLocationName, value: currentTankLocationId}];
                    }
                    
                    this.setState({locations, baseLocations});
                }
            });

        
    }

    fetchAssetTypes(){
        apiRequest('/api/tanks/lookups/tank-asset-types')
            .then(x => {
                if(x.data){
                    this.setState({
                        assetTypes: mustBeArray(x.data).map(v => {
                            return {
                                value: v.id,
                                label: `${v.type} - ${v.name}`
                            };
                        })
                    });
                }
            });
    }
    
    handleConfirmPrint(e) {
        e.preventDefault();
        toastr.info('Creating PDF label...');
        let {printOffset, lookupTank} = this.state;

        apiRequest(`/api/labels/printTank?tankId=${lookupTank.id}&offset=${printOffset}`, 'GET', false)
            .then(x => {
                toastr.success('Created PDF label!');
                this.toggleModal();
                x.data.blob().then(blob => {
                    FileSaver.saveAs(blob, `tank_${lookupTank.id}_label.pdf`);
                });
            });
    }
    
    toggleModal(){
        let {isModalOpen} = this.state;
        
        this.setState({isModalOpen: !isModalOpen, printOffset: 0});
    }
    
    handleCancel(){
        this.props.dispatch(push(`${BASE_URL}/manage/tanks`));
    }
    
    
    
    handleLookupTank() {
        let {selectedTank, recordLocation} = this.state;
        let {tankId, userLocation} = this.props;
        let {latitude, longitude} = GetUserLocation(userLocation);        
        if(!recordLocation){
            latitude = null;
            longitude = null;
        }
        
        this.setState({lookupTank: null}, ()=> {
            if(selectedTank.tankId !== tankId){
                this.props.dispatch(push(`${BASE_URL}/manage/tanks/${selectedTank.tankId}`));
            } else {

                apiRequest(`/api/tanks/?id=${selectedTank.tankId}&latitude=${latitude}&longitude=${longitude}`)
                    .then(x => {
                        if (x.data && x.data.notFound === true) {
                            toastr.error(`Tank #${selectedTank.tankId} information NOT found`);
                            this.setState({lookupTank: null, canScan: true});
                        } else {
                            this.setState({lookupTank: x.data, canScan: true});
                        }
                    });
            }
        });
    }

    handleSaveTank() {
        let { lookupTank } = this.state;
        const updatedLookupTank = {
          ...lookupTank,
          oilTypes: mustBeArray(
            lookupTank.oilTypes ? lookupTank.oilTypes.split(",") : ""
          ),
        };

        apiPost(`/api/tanks/save`, updatedLookupTank).then((x) => {
          if (x.data) {
            this.setState({ lookupTank: x.data });
            toastr.success("Saved!");
          } else {
            toastr.error(`Error while saving!`);
          }
        });
    }

    handleSetTankId(e) {
        let tankId = parseInt(e.target.value);
        let {selectedTank} = this.state;

        if (tankId > 0) {
            this.setState({selectedTank: {...selectedTank, tankId}, lookupTank: null});
        } else {
            this.setState({selectedTank: {...selectedTank, tankId: null}, lookupTank: null});
        }
    }

    onScan(data) {
        let {selectedTank, canScan} = this.state;

        if (data && canScan) {
            if (data.includes('?')) {
                let split = data.split('?');
                let query = querySearch(`?${split[1]}`);

                if(selectedTank.tankId !== query.tankId) {
                    this.setState({
                        selectedTank: {...selectedTank, tankId: query.tankId},
                        lookupTank: null,
                        canScan: false
                    }, () => {
                        this.handleLookupTank();
                    });
                }

            } else {
                this.setState({scanResult: data, canScan: true, status: 'Scan does not contain a tankId'});
            }
        }
    }

    fetchTanks() {
        apiRequest('/api/tanks/alltanks')
            .then(x => {
                if (x.data && x.data.length > 0) {
                    this.setState({availableTanks: x.data.map(y => {
                            return {
                                value: y.tankSizeId,
                                label: `${y.tankTypeName} (${y.maxCapacityLitres}L / ${y.pickupCapacityLitres}L)`,
                            };
                        })});    
                }
            });
    }

    fetchOilTypes(){
        apiRequest('/api/tanks/oiltypes')
            .then(res => {
                this.setState({
                    oilTypes: mustBeArray(res.data)
                });
            });
    }
    
    onScanError(data){
        console.log(data);
    }
    
    componentDidMount() {
        this.loadTank();
        //this.fetchOilTypes();
        this.fetchAssetTypes();
    }
    
    loadTank(){
        let {tankId} = this.props;
        let {selectedTank} = this.state;

        if(tankId > 0){
            this.fetchTanks();
            this.setState({selectedTank: {...selectedTank, tankId}, lookupTank: null}, this.handleLookupTank);
        } else {
            this.setState({selectedTank: {...selectedTank, tankId: null}, lookupTank: null});
        }
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.tankId !== this.props.tankId){
            this.loadTank();   
        }
        
        if(prevState.lookupTank === null && this.state.lookupTank !== null){
            this.fetchLocations();
        }
    }

    render(){
        let {selectedTank, lookupTank, availableTanks, isModalOpen, printOffset, locations, baseLocations, recordLocation, oilTypesOptions, assetTypes} = this.state;
        let {tankId, userLocation} = this.props;
        let canPrint = () => {
            let intValue = parseInt(printOffset);
            return (isNaN(intValue) || intValue < 0);
        }
        let {latitude, longitude, hasUserLocation} = GetUserLocation(userLocation);        
        
        return (<div>

            { IsNullOrUndefined(lookupTank) || IsNullOrUndefined(lookupTank.id) ? <form onSubmit={e => {
                e.preventDefault();
                this.handleLookupTank();
                }}>
                <div className={"row"}>
                    <div className={"col-12"}>
                        <h4>Tank Management</h4>
                        <p>Lookup a tank by scanning it or entering the Tank ID</p>                        
                    </div>                    
                </div>
                {hasUserLocation ?
                    <Aux>
                        <div className={"form-group row"}>
                            <div className={"col-6 text-warning"}>
                                On lookup - current tank location will {recordLocation ? '' : 'NOT'} be set to <a href={`http://maps.google.com/maps?&z=21&q=${latitude}+${longitude}`}
                                                                                                                  target={'_blank'}>{`${latitude}, ${longitude}`}</a>
                            </div>
                        </div>
                        <CheckBoxControl
                            name="recordLocation"
                            value={recordLocation}
                            onChange={(e) => this.setState({recordLocation: e.target.checked})}
                            labelText={"Record location?"}
                        />
                    </Aux>
                    :
                    <div className={"form-group row"}>
                        <div className={"col-6 text-danger"}>
                            Device location not on!
                        </div>
                    </div>
                }
                <div className={"form-group row"}>
                    <div className={"col-6"}>
                        <Label for="tankId">Tank #</Label>
                        <Input type="number"
                               name="tankId"
                               id="tankId"
                               value={IsNullOrUndefined(selectedTank) || IsNullOrUndefined(selectedTank.tankId) ? '' : selectedTank.tankId}
                               onChange={this.handleSetTankId}
                        />
                        <Button color="info"
                                className={"mt-1"}
                                disabled={IsNullOrUndefined(selectedTank) || IsNullOrUndefined(selectedTank.tankId) || selectedTank.tankId < 0}
                                onClick={this.handleLookupTank}>Lookup
                            Tank</Button>
                    </div>
                    <div className={"col-4"}>
                        <QrReader
                            delay={300}
                            onError={this.onScanError}
                            onScan={this.onScan}
                            style={{ width: '100%' }}
                        />
                    </div>
                </div>                
                
            </form> :
            
            <Aux>
                <form>
                    <div className={"row"}>
                        <div className={"col-12"}>
                            <h4>Managing Tank #{lookupTank.id}</h4>
                            <p><Link to={`${BASE_URL}/manage/tanks`}>Manage another tank...</Link></p>
                        </div>
                    </div>
                    <div className={"form-group row"}>
                        <label className={"col-2 col-form-label"}>Base location</label>
                        <div className={"col-6"}>
                            <Select
                                name="baseTankLocationId"
                                value={lookupTank.baseTankLocationId}
                                multi={false}
                                clearable={false}
                                simpleValue={true}
                                options={baseLocations}
                                onChange={(val) => this.setState({lookupTank: {...lookupTank, baseTankLocationId: val}})}
                            />
                        </div>
                    </div>
                    <TextViewControl labelText={"Tank Id"} value={lookupTank.idWithPrefix} />
                    <div className={"form-group row"}>
                        <label className={"col-2 col-form-label"}>Tank</label>
                        <div className={"col-6"}>
                            <Select
                                name="tankSizeId"
                                value={lookupTank.tankSizeId}
                                multi={false}
                                clearable={false}
                                simpleValue={true}
                                options={availableTanks}
                                onChange={(val) => this.setState({lookupTank: {...lookupTank, tankSizeId: val}})}
                            />
                        </div>
                    </div>
                    <div className={"form-group row"}>
                        <label className={"col-2 col-form-label"}>Asset</label>
                        <div className={"col-6"}>
                            <Select
                                name="tankSizeId"
                                value={lookupTank.assignedAssetTypes[0]}
                                multi={false}
                                clearable={false}
                                simpleValue={true}
                                options={assetTypes}
                                onChange={(val) => this.setState({lookupTank: {...lookupTank, assignedAssetTypes: [val]}})}
                            />
                        </div>
                    </div>

                    {/* Saved for adding oil type in tank  */}
                    {/* <div className={"form-group row"}>
                        <label className={"col-2 col-form-label"}>Oil Type</label>
                        <div className={"col-6"}>
                            <Select
                                name="tankSizeId"
                                value={lookupTank.oilTypes}
                                multi={false}
                                clearable={false}
                                simpleValue={true}
                                options={oilTypesOptions}
                                onChange={(val) => this.setState({lookupTank: {...lookupTank, oilTypes: val}})}
                            />
                        </div>
                    </div> */}
                    
                    <div className={"form-group row"}>
                        <label className={"col-2 col-form-label"}>Status</label>
                        <div className={"col-6"}>
                            <Select
                                name="tankStatusType"
                                value={lookupTank.tankStatusType}
                                multi={false}
                                clearable={false}
                                simpleValue={true}
                                options={TankStatusTypes}
                                onChange={(val) => this.setState({lookupTank: {...lookupTank, tankStatusType: val}})}
                            />
                        </div>
                    </div>
                    <CheckBoxControl
                        name="hasHeater"
                        value={lookupTank.hasHeater}
                        onChange={(e) => this.setState({lookupTank: {...lookupTank, hasHeater: e.target.checked}})}
                        labelText={'Has heater?'}
                    />
                    <TextViewControl labelText={"Current location"} value={lookupTank.currentTankLocationName} />
                    <TextViewControl labelText={"Is at base location?"} value={lookupTank.currentTankLocationIsBase ? 'Yes' : 'No'} />
                    <TextViewControl labelText={"Is considered pending?"} value={lookupTank.isConsideredPending ? 'Yes' : 'No'} />                    
                    <div className={"form-group row"}>
                        <label className={"col-2 col-form-label"}>Re-set location</label>
                        <div className={"col-6"}>
                            <Select
                                name="currentTankLocationId"
                                value={lookupTank.currentTankLocationId}
                                multi={false}
                                clearable={false}
                                simpleValue={true}
                                options={locations}
                                onChange={(val) => this.setState({lookupTank: {...lookupTank, currentTankLocationId: val}})}
                            />
                        </div>
                    </div>
                    
                    <div className="form-group row">
                        <label className="col-md-2 col-xs-3 col-sm-3 form-control-label">Last lat/lng</label>
                        <div className="col-md-8 col-xs-10 col-sm-10 ">
                            {IsNullOrUndefined(lookupTank.latitude) || IsNullOrUndefined(lookupTank.longitude) ? 'Unknown' :
                                <a href={`http://maps.google.com/maps?&z=21&q=${lookupTank.latitude}+${lookupTank.longitude}`}
                                   target={'_blank'}>{`${lookupTank.latitude}, ${lookupTank.longitude}`}</a>
                            }
                        </div>
                    </div>
                    <div className={"form-group row"}>
                        <div className={"col-6"}>
                            <Button color="primary"              
                                    className={"mr-1"}        
                                    onClick={this.handleSaveTank}>Save</Button>
                            <Button color="warning"
                                    className={"mr-1"}
                                    onClick={this.toggleModal}>Print</Button>
                            <Button color="secondary"
                                    onClick={this.handleCancel}>Cancel</Button>
                        </div>
                    </div>
                </form>


                {lookupTank.runs.length > 0 &&
                <div className="row mb-2 mt-2">
                    <div className="col-md-12">
                        <b>Run History</b>
                    </div>
                </div> }
                <div className="row">
                    <div className="col-md-12">
                        <ul className="list-group"> {lookupTank.runs.map(run => (
                            <li
                                className={`list-group-item list-group-item-${run.isComplete ? 'success' : run.isPending ? 'warning' : 'danger'}`}
                                key={run.id}>
                                <a href={`${BASE_URL}/runs/search/${run.id}/locations/${lookupTank.currentTankLocationId}`} target={'_blank'}>
                                    {moment(run.timeStart).format(SHORT_DATE_FORMAT)} - #{run.id}</a>
                            </li>
                        ))}
                        </ul>
                    </div>
                </div>
                
            </Aux> }

            <Modal isOpen={isModalOpen} toggle={this.toggleModal}>
                <ModalHeader>
                    Print Tank Label
                </ModalHeader>
                <ModalBody>
                    <p>Set print offset (where labels will start)</p>
                    <Form>
                        <TextBoxControl 
                            labelText={"Offset"} 
                            value={printOffset}
                            type={"number"}
                            onChange={(e)=> {
                                this.setState({printOffset: e.target.value});
                            }} />
                    </Form>
                </ModalBody>
                <ModalFooter>                    
                    <FormGroup>
                         <Button color="primary"
                              className={"mr-1"}
                                 disabled={canPrint()}
                              onClick={this.handleConfirmPrint}>Print</Button>
                        <Button onClick={this.toggleModal} color={"secondary"}>Cancel</Button>
                    </FormGroup>
                </ModalFooter>
            </Modal>
        </div>);
    }
}
TankManagementPage.propTypes = {
    tankId: PropTypes.number,
};

function mapStateToProps(state, ownProps){
    let id = -1;
    if(ownProps.routeParams && ownProps.routeParams.id){
        id = parseInt(ownProps.routeParams.id);
    } else if(ownProps.locationId) {
        id = ownProps.locationId;
    }
    
    return {
        tankId: id,
        userLocation: state.location,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TankManagementPage));